var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1751984377932,
    className: "icon",
    viewBox: "0 0 1194 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13179,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1072.297773 0.000853H122.111898A79.018601 79.018601 0 0 0 42.666631 78.507455v624.639479c0 43.349297 35.58397 78.506601 79.445267 78.506601H554.666204v159.317201H417.706319a16.383986 16.383986 0 0 0-16.46932 16.639986v45.141296c0 9.215992 6.826661 16.639986 16.981319 16.639986h360.618366c9.386659 0 17.066652-7.253327 17.066653-16.639986v-45.226629a17.237319 17.237319 0 0 0-16.72532-16.554653H639.999467V781.568202h432.554306a79.018601 79.018601 0 0 0 79.445267-78.506601V78.336788A79.274601 79.274601 0 0 0 1072.297773 0.000853z m0 705.620746H123.391897V78.336788h949.076543v627.199477h-0.170667z",
    fill: "currentColor",
    "p-id": 13180
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.47969 297.472605c0 9.557325 8.277326 17.407985 17.066652 17.407986h445.524962c9.386659 0 17.066652-6.997328 17.066653-17.407986v-40.191966a17.663985 17.663985 0 0 0-17.066653-17.407986H389.546342c-9.386659 0-17.066652 6.826661-17.066652 17.407986v40.106633z m0 224.853146c0 9.557325 8.277326 17.322652 17.066652 17.322653h445.524962c9.386659 0 17.066652-6.826661 17.066653-17.322653v-40.277299a17.663985 17.663985 0 0 0-17.066653-17.322653H389.546342c-9.386659 0-17.066652 6.826661-17.066652 17.322653v40.277299z",
    fill: "currentColor",
    "p-id": 13181
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.a8d56288dca0f28f3030875c67ee15df.svg";
export { ForwardRef as ReactComponent };